<template>
    <h4>Looking Forward Contract Expiration</h4>

    <div class="legend">
        <div class="redDate legendItem">
            Expired
        </div>
        <div class="orangeDate legendItem">
            Expires within 30 Days
        </div>
        <div class="yellowDate legendItem">
            Expires within 60 Days
        </div>
        <div class="purpleDate legendItem">
            Expires within 90 Days
        </div>
    </div>

    <DataTableComponent v-if="this.getAllUrl"
                        :data-url="this.getAllUrl"
                        :column-list-d-b="this.personDataColumnNames"
                        :column-list-pretty="this.personDataColumnNamesPretty"
                        :date-column-indexes="[2,5]"
                        :order-column-index="0"
                        :rows-per-page="-1"
                        :show-search="true"
                        plural-data-name="contracts"
                        order-direction="asc"
                        ref="personsDatatable"
                        :show-action-column="false"
                        :show-paging="false">

        <template v-slot:extraColumnHeaders>


            <th>Contract End Date</th>
            <th>Last Confirmation</th>
            <th>Notes</th>
            <th>AAL Expiration Date</th>

        </template>


        <template #extraColumns="extraColumnRowData">


            <td :data-sort="extraColumnRowData.contractEndDate" :class="getColorFromDate(extraColumnRowData.conexp)">
                {{ extraColumnRowData.contractEndDate }}
            </td>
            <td :data-sort="extraColumnRowData.caamsConfDateExp" :class="getColorFromDate(extraColumnRowData.caamsConfDateExp)">
                {{ extraColumnRowData.caamsConfDateExp }}
            </td>
            <td :data-sort="extraColumnRowData.contractNotes" :class="getColorFromDate(extraColumnRowData.contractNotes)">
                {{ extraColumnRowData.contractNotes }}
            </td>

            <td :data-sort="extraColumnRowData.caamsaalExp" :class="getColorFromDate(extraColumnRowData.aalexp)">
                {{ extraColumnRowData.caamsaalExp }}
            </td>


        </template>


    </DataTableComponent>

</template>


<script>
    import DataTableComponent from "@/components/dataSupport/DataTable.vue";
    import { store } from "@/store/store.js";


    export default {
        components: {
            DataTableComponent,

        },
        data() {
            return {
                getAllUrl: null,
                store,
                personDataColumnNames: ['contractId', 'contractNumber', 'caamSnum'],
                personDataColumnNamesPretty: ['Contract ID', 'Contract Number', 'Number on Contract'],
            }
        },
        created() {
            this.getAllUrl = store.webAPIUrl + "LookingForward";
            console.log('data: ' + this.getAllUrl);
        },
        computed: {},
        methods: {
            getColorFromDate(expVal) {

                if (expVal == "expired") {
                    return "redDate";
                }
                if (expVal == "thirty") {
                    return "orangeDate";
                }
                if (expVal == "sixty") {
                    return "yellowDate";
                }
                if (expVal == "ninety") {
                    return "purpleDate";
                }
            }
        },
    };
</script>

<style scoped>
    .purpleDate {
        background-color: rgb(249, 137, 249);
        text-transform: capitalize;
    }

    .yellowDate {
        background-color: yellow;
        text-transform: capitalize;
    }

    .orangeDate {
        background-color: orange;
        text-transform: capitalize;
    }

    .redDate {
        background-color: rgb(253, 179, 179);
        text-transform: capitalize;
    }

    .legend {
        display: flex;
        justify-content: space-around;
        width: 665px;
    }

    .legendItem {
        border-radius: 8px;
        padding: 5px;
    }
</style>
